import React, { useState } from 'react';
import clsx from 'clsx';

import {
  Drawer,
  Box,
  AppBar,
  Toolbar,
  List,
  CssBaseline,
  Typography
} from '@mui/material';

import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

// Components
import { RoutesConstants } from '@/main/routes/routesConstants';
import DrawerMenuItemComponent from './drawerMenuItemComponent';
import HeaderUserBoxComponent from '../../header/headerUserBox/headerUserBoxComponent';

// Redux
import { useUserReducer } from '@/main/store/user';
import { setOpenMenu, useMenuReducer } from '../../../store/menu';

// Models
import { MenuResponse } from '../../../models/response/menu';

// Styles
import { useStyles } from './styles';
import * as S from './styles';
import { getLuminance, useTheme, getContrastRatio } from '@mui/material/styles';
import { getCommonColors } from '@style/styleMaterialUIGlobal';
import { useVisualIdentityReducer } from '@/main/store/visualIdentity';

export default function DrawerMenuComponent(props: { data: MenuResponse[] }) {
  const classes = useStyles();
  const theme = useTheme();
  const commonColors = getCommonColors(theme);
  const menuReducer = useMenuReducer();
  const userReducer = useUserReducer();
  const { visualIdentity: visualIdentityReducer } = useVisualIdentityReducer();
  const textColor = theme.palette.getContrastText(visualIdentityReducer.colors?.headerColor);

  const dispatch = useDispatch();

  const [parentMenuSelected, setParentMenuSelected] = useState('');

  const handleDrawerOpen = () => {
    dispatch(setOpenMenu(true));
  };

  const handleDrawerClose = () => {
    dispatch(setOpenMenu(false));
  };

  function renderMenuItems() {
    return props.data.map((menu: MenuResponse) => {
      return (
        <DrawerMenuItemComponent
          key={menu.idModule}
          menu={menu}
          open={menuReducer.open}
          setParentMenuSelected={setParentMenuSelected}
          preOpenMenu={parentMenuSelected === menu.name}
          parentMenuSelected={parentMenuSelected}
        />
      );
    });
  }

  function renderIconMenu() {
    return (
      <IconButton
        className="btn-action-drawer"
        style={{ marginRight: 10 }}
        onClick={!menuReducer.open ? handleDrawerOpen : handleDrawerClose}>
        {!menuReducer.open ? (
          <MenuIcon style={{ color: textColor, width: 18 }} />
        ) : (
          <ChevronLeftIcon style={{ color: textColor, width: 18 }} />
        )}
      </IconButton>
    );
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={classes.containerAppBar}
        style={{ zIndex: menuReducer.open ? 1400 : 2 }}>
        <Toolbar className="toolbar-drawer-menu">
          {renderIconMenu()}
          <S.AreaLogo>
            <img src={visualIdentityReducer.logoUrl} alt="" />
          </S.AreaLogo>
          <Box
            className="d-flex align-items-center"
            style={{ flexGrow: 1, justifyContent: 'flex-end' }}>

            <Box className={classes.containerActions}>
              <HeaderUserBoxComponent
                user={{
                  avatar: null,
                  name: userReducer?.currentUser?.name || null,
                  email: userReducer?.currentUser?.email || null
                }}
                companyTradeName={
                  userReducer?.currentUser?.companyTradeName || null
                }
                version={userReducer?.currentUser?.version || null}
              />
            </Box>
          </Box>
        </Toolbar>
      </AppBar>

      <Drawer
        variant="permanent"
        style={{
          width: '100%',
          zIndex: menuReducer.open ? 1399 : 1,
          position: 'absolute'
        }}
        className={`drawer-menu ${clsx(classes.drawer, {
          [classes.drawerOpen]: menuReducer.open,
          [classes.drawerClose]: !menuReducer.open
        })}`}
        classes={{
          paper: clsx(
            { borderRight: 'none' },
            {
              [classes.drawerOpen]: menuReducer.open,
              [classes.drawerClose]: !menuReducer.open
            }
          )
        }}
        onClose={handleDrawerClose}>
        <div className={classes.toolbar} />
        <List>{renderMenuItems()}</List>
      </Drawer>
    </div>
  );
}
